import { type ForwardedRef, useImperativeHandle } from 'react'
import type WaveSurfer from 'wavesurfer.js/dist/wavesurfer.js'
import { type IOnWaveformPlayProps } from 'shared/ui/AudioPlayer/ui/AudioWave/hooks/useWaveform.ts'

export type IUseWaveformApiRef = {
  waveform: WaveSurfer | null
  onWaveformPlay: (data: IOnWaveformPlayProps) => void
}

type IUseWaveformApiRefProps = {
  waveform: WaveSurfer | null
  onWaveformPlay: (data: IOnWaveformPlayProps) => void
}

export const useWaveformApiRef = (
  ref: ForwardedRef<IUseWaveformApiRef>,
  { waveform, onWaveformPlay }: IUseWaveformApiRefProps
) => {
  useImperativeHandle(
    ref,
    () => {
      return {
        waveform: waveform,
        onWaveformPlay: onWaveformPlay,
      }
    },
    [waveform]
  )
}
